// extracted by mini-css-extract-plugin
export default {"root":"DateRangeWithPresets_root__FIbQM","fields":"DateRangeWithPresets_fields__17UfE","presets":"DateRangeWithPresets_presets__vqAAd"};